import {
  useDynamicContext,
  useWalletConnectorEvent,
} from "@dynamic-labs/sdk-react-core";

import { useHandleLogOut } from "#/hooks/useHandleLogOut";
import { Logger } from "#/utils/logger";

export const WalletLockUpdater = () => {
  const { primaryWallet } = useDynamicContext();
  const { handleLogOut } = useHandleLogOut();

  useWalletConnectorEvent(
    primaryWallet?.connector,
    "disconnect",
    (connector) => {
      handleLogOut();

      Logger.info(
        "Wallet Lock Updater",
        `Connector disconnected: ${connector.name}`,
      );
    },
  );

  return null;
};
